/**
 * @generated SignedSource<<d8c03e412a2ffac5206ad3f2be614843>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type JoinRemindListInput = {
  gameId: string;
};
export type RemindButtonJoinMutation$variables = {
  input: JoinRemindListInput;
};
export type RemindButtonJoinMutation$data = {
  readonly joinRemindList: {
    readonly game: {
      readonly id: string;
      readonly viewerIsOnRemindMeList: boolean;
    } | null;
    readonly user: {
      readonly id: string;
      readonly hideRemindModal: boolean;
    } | null;
  } | null;
};
export type RemindButtonJoinMutation = {
  variables: RemindButtonJoinMutation$variables;
  response: RemindButtonJoinMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JoinRemindListPayload",
    "kind": "LinkedField",
    "name": "joinRemindList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Game",
        "kind": "LinkedField",
        "name": "game",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerIsOnRemindMeList",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hideRemindModal",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemindButtonJoinMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemindButtonJoinMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f90c65ecdb9cbf8464ef4194e2eb02d2",
    "id": null,
    "metadata": {},
    "name": "RemindButtonJoinMutation",
    "operationKind": "mutation",
    "text": "mutation RemindButtonJoinMutation(\n  $input: JoinRemindListInput!\n) {\n  joinRemindList(input: $input) {\n    game {\n      id\n      viewerIsOnRemindMeList\n    }\n    user {\n      id\n      hideRemindModal\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "420fe9ff7c0c5f9cd2fb9f88903c6cf6";

export default node;
